export default {
  default: () => import("/var/www/html/profile_wowup_nuxt3/layouts/default.vue").then(m => m.default || m)
}